declare global {
  interface Window {
    fbq: (action: string, event: string, params?: Record<string, any>) => void
    _fbq: any
  }
}

export const initMetaPixel = (pixelId: string) => {
  if (typeof window === 'undefined') return

  // Meta Pixel initialization script
  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  if (f.fbq) return
  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  const s = b.getElementsByTagName(e)[0]
  s.parentNode?.insertBefore(t, s)

  // Initialize pixel and track PageView
  window.fbq('init', pixelId)
  window.fbq('track', 'PageView')
}

export const trackAddToCart = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
